<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

<CCardHeader>
  {{$t('sidebars.tracking')}}
</CCardHeader>
          <CCardBody>
            <div :style="{ height: '450px'}" id='map'></div>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
import mapboxgl from "mapbox-gl";

export default {
  name: 'DeliveryTrackingComponent',
  components: {
    BTabs,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];
this.createMap()

  }, watch: {


  },
  methods: {
    createMap() {
      var self = this;
      // init the map
      mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
      if (mapboxgl.getRTLTextPluginStatus() == "unavailable") {
        mapboxgl.setRTLTextPlugin(
            'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
            null,
            true // Lazy load the plugin
        );
      }

      var center_loc = [51.37734351262877, 35.697451890638886];
      if (self.$i18n.locale == 'en') {
        center_loc = [-0.03880407284764019, 51.573360744046745];
      }
      self.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        center: center_loc,
        zoom: 14 // starting zoom
      });


      // self.map.addControl(self.polygon_draw);
      // self.map.on('draw.create', self.updatePolygonArea);
      // self.map.on('draw.delete', self.updatePolygonArea);
      // self.map.on('draw.update', self.updatePolygonArea);

      // self.map.addControl(new mapboxgl.Navigation())
      self.map.on('click', function (e) {
        if (self.marker != null) {
          self.marker.remove();
        }
        // if (self.user_location_lat == 0) {

        // }



        console.log('A click event has occurred at ' + e.lngLat);
        // }

      });

      self.map.on('load', function () {
        const custom_marker = document.createElement('div');
        custom_marker.className = 'custom_marker';

        new mapboxgl.Marker(custom_marker)

            .setLngLat(new mapboxgl.LngLat(-0.027413920169180983,51.57860735314557))
            .setPopup(
                new mapboxgl.Popup({ offset: 25 }) // add popups
                    .setHTML(
                        `<h3>S1156</h3><p>Nova Co</p>`
                    )
            )
            .addTo(self.map);
//*****************************************
      const custom_marker2 = document.createElement('div');
        custom_marker2.className = 'custom_marker';

        new mapboxgl.Marker(custom_marker2)

            .setLngLat(new mapboxgl.LngLat(-0.04805232953231098, 51.57188331884839))
            .setPopup(
                new mapboxgl.Popup({ offset: 25 }) // add popups
                    .setHTML(
                        `<h3>S1101</h3><p>Mr Smith</p>`
                    )
            )
            .addTo(self.map);
//*****************************************
const custom_marker3 = document.createElement('div');
        custom_marker3.className = 'custom_marker';

        new mapboxgl.Marker(custom_marker3)

            .setLngLat(new mapboxgl.LngLat(-0.02195980023566335, 51.5714031974164))
            .setPopup(
                new mapboxgl.Popup({ offset: 25 }) // add popups
                    .setHTML(
                        `<h3>S1121</h3><p>John Abdi</p>`
                    )
            )
            .addTo(self.map);
//*****************************************

      });
    },

  }
}

</script>
<style>

.custom_marker {
  background-image: url('/img/motorcycle.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
</style>